<template>
  <div id="app" :class="{en:language!=='zh'}">
    <router-view v-if="isRouterAlive" />
    <service v-if="!unShowService" />
  </div>
</template>

<script>
import service from "./components/service.vue";
export default {
  name: "App",
  components: {
    service
  },
  data() {
    return {
      isRouterAlive: true,
      oldHash: location.hash
    };
  },
  created() {
    if (sessionStorage.getItem("store")) {
      this.$store.replaceState(
        Object.assign(
          {},
          this.$store.state,
          JSON.parse(sessionStorage.getItem("store"))
        )
      );
    }
    if (localStorage.getItem("isLogin")) {
      const isLogin = localStorage.getItem("isLogin") === "true" ? true : false;
      this.$store.dispatch("changeLogin", isLogin);
    }
    window.addEventListener("beforeunload", () => {
      sessionStorage.setItem("store", JSON.stringify(this.$store.state));
    });
    this.getInfo();
  },
  provide() {
    return {
      reload: this.reload
    };
  },
  mounted() {
    window.addEventListener("popstate", this.refresh, false);
  },
  destroyed() {
    window.removeEventListener("popstate", this.refresh);
  },
  methods: {
    getInfo() {
      let auth_token = localStorage.getItem("auth_token");
      if (auth_token) {
        this.$http.get("/api/customer/info/get").then((response) => {
          if (response.code !== "ServiceError") {
            if (response.data.userLanguage == "0") {
              localStorage.setItem('language', '#!zh');
            }
            if (response.data.userLanguage == "1") {
              localStorage.setItem('language', '#!en');
            }
          }
        });
      }
    },
    refresh(event) {
      const newHash = event.target.location.hash;
      if (this.oldHash !== newHash) {
        this.oldHash = newHash;
        location.reload();
      }
    },
    reload() {
      this.isRouterAlive = false;
      this.$nextTick(function() {
        this.isRouterAlive = true;
      });
    }
  },
  computed: {
    unShowService() {
      if (
        this.$route.name === "videoIframe" ||
        this.$route.name === "contestHome" ||
        this.$route.name === "contestPage" ||
        this.$route.name === "contestAwards" ||
        this.$route.name === "competitionWorks" ||
        this.$route.name === "information" ||
        this.$route.name === "shortlistedEntries"
      ) {
        return true;
      }
      return false;
    },
    language() {
      return this.$language();
    }
  },
  watch: {
    $route(val) {
      setTimeout(() => {
        this.oldHash = val.hash;
      }, 100);
    }
  }
};
</script>

<style lang="stylus" scoped>
#app {
  font-family: PingFangSC-Regular, PingFangSC-Semibold, PingFang SC;

  &.en {
    font-family: "Nunito Sans"!important;
  }
}
</style>
<style lang="stylus" >
.icon-loading {
  display: inline-block;
  background: rgba(0, 0, 0, 0.4) url('/static/MANA_loading.gif') 12px no-repeat;
  background-size: 45px;
  width: 45px;
  height: 45px;
  padding: 12px;
  border-radius: 4px;
}
</style>




// WEBPACK FOOTER //
// src/App.vue